const LINKS = [
  { href: "#idea", label: "The Idea" },
  { href: "#elongification", label: "Elongification" },
  { href: "#menu", label: "Menu" },
  { href: "#stores", label: "Stores" },
];

export const Navbar = () => (
  <header className="fixed top-0 left-0 right-0 z-50 bg-pav border-b-4 border-kadak">
    <div className="mx-auto flex max-w-7xl items-center justify-between px-4 sm:px-6 py-3">
      <a href="#top" data-testid="nav-logo" className="flex items-center gap-3">
        <img src="/assets/logo-roundel.png" alt="Vada Sub roundel" className="h-10 w-10 animate-spin-slow" />
        <span className="font-shrikhand text-2xl text-mirchi -rotate-2" style={{ textShadow: "2px 2px 0 #FFC226" }}>
          Vada Sub
        </span>
      </a>
      <nav className="hidden md:flex items-center gap-7">
        {LINKS.map((l) => (
          <a
            key={l.href}
            href={l.href}
            data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
            className="font-anton text-sm uppercase tracking-wide text-kadak transition-colors duration-150 hover:text-mirchi"
          >
            {l.label}
          </a>
        ))}
      </nav>
      <a
        href="#franchise"
        data-testid="nav-franchise-cta"
        className="rounded-full border-4 border-kadak bg-taxi px-4 sm:px-5 py-1.5 font-bungee text-xs sm:text-sm text-kadak sticker-shadow-sm transition-transform duration-150 hover:-translate-y-0.5 hover:-translate-x-0.5"
      >
        OWN A KHOKA
      </a>
    </div>
  </header>
);
